import { gql } from "gql";

export const TEAM_DASHBOARD = gql(/* GraphQL */ `
  query TeamDashboard($filter: TeamDashboardFilter, $page: PageRequest!) {
    getMyPerson {
      management {
        managedHierarchyElement {
          id
        }
      }
    }
    teamDashboard(filter: $filter) {
      ...Stats
      demographyBySex {
        ...DemographySex
      }
      demographyByGeneration {
        ...DemographyGeneration
      }
      teamTasks(page: $page) {
        total
        content {
          ...TeamTask
        }
      }
      absencesAndBusinessTrips(page: $page) {
        total
        content {
          ...TeamAbsenceEvent
        }
      }
      resources(page: $page) {
        total
        content {
          ...TeamResource
        }
      }
      orders(page: $page) {
        total
        content {
          ...TeamOrder
        }
      }
    }
  }
`);
